import { createContext, useContext, useState } from "react"
import { iAppContext, iProvider } from "../types";
import { CLOUDSCAPE_MOBILE_BREAKPOINT } from "../utils/constants";

/** Open on desktop; closed on mobile so the drawer does not cover the page on first paint. */
const getDefaultSideNavOpen = () =>
    typeof window !== "undefined" &&
    !window.matchMedia(`(max-width: ${CLOUDSCAPE_MOBILE_BREAKPOINT}px)`).matches;

export const AppContext = createContext<iAppContext>({
    isSideNavOpen: true,
    initialSideNavOpenState: true,
    setInitialSideNavOpenState: () => { },
    setIsSideNavOpen: () => { },
    issueCount: 0,
    setIssueCount: () => { },
    inboxCount: 0,
    setInboxCount: () => { },
});

// eslint-disable-next-line react-refresh/only-export-components
export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }: iProvider) => {
    const [isSideNavOpen, setIsSideNavOpen] = useState<boolean>(getDefaultSideNavOpen);
    const [initialSideNavOpenState, setInitialSideNavOpenState] = useState<boolean>(getDefaultSideNavOpen);
    const [issueCount, setIssueCount] = useState<number>(0);
    const [inboxCount, setInboxCount] = useState<number>(0);

    const value = { isSideNavOpen, setIsSideNavOpen, initialSideNavOpenState, setInitialSideNavOpenState, issueCount, setIssueCount, inboxCount, setInboxCount };

    return (
        <AppContext.Provider value={value}>{children}</AppContext.Provider>
    );
};
